import * as React from 'react'
import {Box} from "@mui/material"


export default function mappedShareColumn() {
	return {
		name: "mappedProductShare", label: "Mapped Product",
		options: {
			filter: false,
			customBodyRowRenderLite: (value, {mappedProduct}) => <Box sx={{textAlign: 'center'}}>
					{mappedProduct ? `${value} % (${mappedProduct})` : '0'}
				</Box>
		}
	}
}


